import {AfterViewInit, Component, ElementRef, Inject, ViewChild} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Coordinates} from '@domain/coordinates';
import {Unit} from '@vdw/angular-component-library';
import {isUndefined, subtract, sum} from 'lodash-es';

@Component({
  templateUrl: './edit-production-schedule-path-of-colored-yarn-set.component.html',
  styleUrls: ['./edit-production-schedule-path-of-colored-yarn-set.component.scss']
})
export class EditProductionSchedulePathOfColoredYarnSetComponent implements AfterViewInit {
  @ViewChild('matCardElement', {read: ElementRef}) public matCardElement: ElementRef;

  public readonly commercialUnit: Unit;
  public arrowPosition: Coordinates;

  private readonly dialogRef: MatDialogRef<EditProductionSchedulePathOfColoredYarnSetComponent>;
  private readonly matDialogPosition: Coordinates;
  private readonly cursorOffset = 16;

  public constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    dialogRef: MatDialogRef<EditProductionSchedulePathOfColoredYarnSetComponent>
  ) {
    this.dialogRef = dialogRef;
    this.matDialogPosition = data.matDialogPosition;
  }

  public ngAfterViewInit(): void {
    this.repositionMatDialog();
  }

  public close(): void {
    this.dialogRef.close(false);
  }

  public deleteProductionSchedulePathOfColoredYarnSet(): void {
    this.dialogRef.close(true);
  }

  public canShowArrow(): boolean {
    return !isUndefined(this.arrowPosition);
  }

  private repositionMatDialog(): void {
    if (!isUndefined(this.matDialogPosition)) {
      const {height: matCardHeight}: DOMRect = this.matCardElement.nativeElement.getBoundingClientRect();
      const matDialogPositionTop = subtract(this.matDialogPosition.y, matCardHeight / 2);

      this.dialogRef.updatePosition({
        top: `${matDialogPositionTop}px`,
        left: `${sum([this.matDialogPosition.x, this.cursorOffset])}px`
      });

      setTimeout(() => {
        this.setArrowPositions();
      });
    }
  }

  private setArrowPositions(): void {
    const matIconWidth = 24;
    const matIconHeight = 24;
    const matIconOffset = 4;

    this.arrowPosition = {
      y: this.matDialogPosition.y - matIconHeight / 2,
      x: subtract(this.matDialogPosition.x, matIconWidth) + this.cursorOffset + matIconOffset
    };
  }
}
